<!-- <h3 class="contact-cta">{{ 'CONTACT.TITLE' | translate }}</h3> -->
<ng-content select="[title]"></ng-content>
<a [attr.href]="'tel:'+_store()?.phone">{{ _store()?.phone }}</a>
<a [attr.href]="'mailto:'+_store()?.email">{{ _store()?.email }}</a>
<app-store-address [store]="_store()"></app-store-address>
<p>{{ 'CONTACT.CVR' | translate: {cvr:_store()?.cvr} }}</p>
<!-- <img class="contact-img"
     role="presentation"
     [use]="store()?.contact_image"
     [query]="{ width: '500', height:'500', }"> -->
<ng-content></ng-content>
